import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose className strings with conflict resolution.
 *
 * `clsx` flattens nested arrays, booleans, and objects into a class list.
 * `twMerge` resolves Tailwind class conflicts by keeping the last winner
 * (e.g. `cn('p-2', 'p-4')` → `'p-4'`). Used pervasively in primitives.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
